// extracted by mini-css-extract-plugin
export default {"item":"burger-constructor-item_item__o7AVg"};